import { render, staticRenderFns } from "./BtnAffichageMvtsStock.vue?vue&type=template&id=53513f58&"
import script from "./BtnAffichageMvtsStock.vue?vue&type=script&lang=js&"
export * from "./BtnAffichageMvtsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports